<template>
  <div class="d-flex">
    <router-link to="/dashboard">
      <img class="img-fluid for-light" src="../../assets/images/logo/logo.png" alt="" />
    </router-link>
    <h4 class="fw-bold m-l-5 align-self-center">McDonald's</h4>
  </div>
</template>
<script>

export default {
  name: 'Logo',
};
</script>
